


































































































































import moment from 'moment'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { FullDistribution } from '../../Distribution'
import { DistributionState } from '../../DistributionEditor/types'

@Component({
  data() {
    return {
      moment,
      DistributionState,
    }
  }
})
export default class DistributionCard extends Vue {
  @Prop() distribution!: FullDistribution

  @Prop() goToDistribution!: (id: string) => void

  @Prop() goToCopyDistribution!: (id: string) => void

  @Prop() goToEditDistribution!: (id: string) => void

  @Prop() cancelDistribution!: (id: number) => void

  get stateColor(): string {
    switch(this.distribution.state) {
      case DistributionState.Success:
        return '105, 183, 68'
      case DistributionState.Start:
        return '92, 173, 255'
      case DistributionState.Error:
        return '247, 78, 87'
      case DistributionState.Cancel:
        return '251, 118, 73'
      case DistributionState.Wait:
        return '92, 173, 255'
      default:
        return ''
    }
  }

  get stateIcon(): string {
    switch(this.distribution.state) {
      case DistributionState.Success:
        return 'check-circle'
      case DistributionState.Start:
        return 'loading'
      case DistributionState.Error:
        return 'exclamation-circle'
      case DistributionState.Cancel:
        return 'stop'
      case DistributionState.Wait:
        return 'clock-circle'
      default:
        return ''
    }
  }

  get progressStatus(): 'success' | 'exception' | 'active' | 'cancel' {
    switch (this.distribution.state) {
      case DistributionState.Start:
        return 'active'
      case DistributionState.Error:
        return 'exception'
      case DistributionState.Success:
        return 'success'
      case DistributionState.Cancel:
        return 'cancel'
      default:
        return 'active'
    }
  }

  get progressPercent(): number {
    const { success, total, failed } = this.distribution

    const successCheck = success !== undefined && success !== null
    const totalCheck = total !== undefined && total !== null
    const failedCheck = failed !== undefined && failed !== null

    if (successCheck && totalCheck && failedCheck) {
      if (total > 0 && success > 0) {
        return Math.floor(((success + failed) / total!) * 100)
      } else {
        return 100
      }
    }

    return 0
  }

  get cardText() {
    const distributionText = this.distribution.content.templates[0].text

    if (distributionText.length > 300) {
      return `${ distributionText.slice(0, 297) }...`
    }

    return distributionText
  }
}
